export default __webpack_public_path__ + "static/media/template6.1b33ba40.png";